import Navbar from '@/pages/home/components/Navbar';
import HeroSection from '@/pages/home/components/HeroSection';
import CategoryDropdown from '@/pages/home/components/CategoryDropdown';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import TrustSection from '@/pages/home/components/TrustSection';
import WhatIsSection from '@/pages/home/components/WhatIsSection';
import ArticleGrid from '@/pages/home/components/ArticleGrid';
import FAQSection from '@/pages/home/components/FAQSection';
import Footer from '@/pages/home/components/Footer';

const homePageSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: 'Oopbuy Spreadsheet Guide',
      url: 'https://oopbuyspread.store',
      description: 'Der umfassendste deutsche Guide f\u00fcr Oopbuy Spreadsheet. Finde gepr\u00fcfte Produkte, Verk\u00e4ufer und Kategorien f\u00fcr sicheres Online-Shopping.',
      logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/5133451b25e408e4a25e4df97e05add8.jpeg',
    },
    {
      '@type': 'WebSite',
      name: 'Oopbuy Spreadsheet Guide Deutschland',
      url: 'https://oopbuyspread.store',
      description: 'Der umfassendste deutsche Guide f\u00fcr Oopbuy Spreadsheet. Finde gepr\u00fcfte Produkte, Verk\u00e4ufer und Kategorien f\u00fcr sicheres Online-Shopping.',
      inLanguage: 'de',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://oopbuyspread.store/?s={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Startseite',
          item: 'https://oopbuyspread.store/',
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homePageSchema) }}
      />

      <Navbar />

      <main>
        <article>
          <HeroSection />
          <CategoryDropdown />
          <CategoryGrid />
          <TrustSection />
          <WhatIsSection />
          <ArticleGrid />
          <FAQSection />
        </article>
      </main>

      <Footer />
    </>
  );
}